import { useEffect, useState } from 'react';

const FloatingElements3D = ({ count = 6 }) => {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    // Generate random positions and sizes for floating elements
    const newElements = Array.from({ length: count }, (_, i) => ({
      id: i,
      top: `${Math.random() * 80 + 10}%`,
      left: `${Math.random() * 80 + 10}%`,
      size: Math.random() * 60 + 40,
      delay: i * 2,
      duration: Math.random() * 6 + 8,
      shape: ['cube', 'sphere', 'pyramid'][Math.floor(Math.random() * 3)],
    }));
    setElements(newElements);
  }, [count]);

  const renderShape = (shape, size) => {
    switch (shape) {
      case 'cube':
        return (
          <div
            className="rounded-sm border-2 border-[#0f7699]/10 bg-[#0f7699]/5 preserve-3d rotate-x-45 rotate-y-45"
            style={{ width: size, height: size }}
          />
        );

      case 'sphere':
        return (
          <div
            className="rounded-full border-2 border-[#0f7699]/10 bg-[radial-gradient(circle_at_30%_30%,rgba(15,118,153,0.05),transparent)]"
            style={{ width: size, height: size }}
          />
        );

      case 'pyramid':
        return (
          <div
            className="w-0 h-0 border-x-transparent border-b-[#0f7699]/15 drop-shadow-[0_0_10px_rgba(15,118,153,0.1)]"
            style={{
              borderLeftWidth: size / 2,
              borderRightWidth: size / 2,
              borderBottomWidth: size,
            }}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {elements.map((element) => (
        <div
          key={element.id}
          className="absolute animate-float3d opacity-40 transition-opacity duration-300 hover:opacity-60"
          style={{
            top: element.top,
            left: element.left,
            animationDuration: `${element.duration}s`,
            animationDelay: `${element.delay}s`,
          }}
        >
          {renderShape(element.shape, element.size)}
        </div>
      ))}
    </div>
  );
};

export default FloatingElements3D;
